import { Link } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Api } from "../api/baseApi";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";

const Contact = () => {
  const { t } = useTranslation();
  const [message, setMessage] = useState(null);

  const validationSchema = Yup.object({
    name: Yup.string()
      .required(t("contactUs.errors.0")), // example: "Name is required"
    email: Yup.string()
      .email(t("contactUs.errors.1")) // example: "Invalid email"
      .required(t("contactUs.errors.2")),
    message: Yup.string()
      
  });

  // ✅ Send function
  const sendContactMessage = async (contactData) => {
    try {
      const { data } = await Api.post(`/api/contactSend`, contactData);
      if (data.status) {
        setMessage({ status: true, message: t("errorMessages.2") });     
      }
      return data;
    } catch (error) {
      console.log(error)
      throw error;
    }
  };


   useEffect(() => {
    if (message) {
      const timer = setTimeout(() => setMessage(null), 4000);
      return () => clearTimeout(timer); 
    }
  }, [message]);

  return (
    <section className="contact padding-t-120 padding-b-60 section-bg position-relative z-index-1 overflow-hidden">
      
      <div className="container container-two">
        <div className="row gy-4">
          <div className="col-lg-5">
            <div className="contact-info">
              <h3 className="contact-info__title">{t("contactUs.contactInfo.title")}</h3>
              <p className="contact-info__desc">{t("contactUs.contactInfo.description")}</p>

              {/* Address + Email */}
              <div className="contact-info__item-wrapper flx-between gap-4">
                <div className="contact-info__item">
                  <span className="contact-info__text text-capitalize d-block mb-1">
                    {t("contactUs.contactInfo.address.0")}
                  </span>
                  <Link
                    to="https://maps.app.goo.gl/hxjcTteKxoST4b2R8"
                    target="_blank"
                    className="contact-info__link font-24 fw-500 text-heading hover-text-main"
                  >
                    {t("contactUs.contactInfo.address.1")}
                  </Link>
                </div>
                <div className="contact-info__item">
                  <span className="contact-info__text text-capitalize d-block mb-1">
                    {t("contactUs.contactInfo.email")}
                  </span>
                  <Link
                    to="mailto:info@nomio.am"
                    className="contact-info__link font-24 fw-500 text-heading hover-text-main"
                  >
                    info@nomio.am
                  </Link>
                </div>
              </div>

              {/* Social links */}
              {/* <div className="mt-24">
                <ul className="social-icon-list">
                  <li className="social-icon-list__item">
                    <Link to="https://www.facebook.com" className="social-icon-list__link text-heading flx-center">
                      <i className="fab fa-facebook-f" />
                    </Link>
                  </li>
                  <li className="social-icon-list__item">
                    <Link to="https://www.twitter.com" className="social-icon-list__link text-heading flx-center">
                      <i className="fab fa-twitter" />
                    </Link>
                  </li>
                  <li className="social-icon-list__item">
                    <Link to="https://www.linkedin.com" className="social-icon-list__link text-heading flx-center">
                      <i className="fab fa-linkedin-in" />
                    </Link>
                  </li>
                  <li className="social-icon-list__item">
                    <Link to="https://www.pinterest.com" className="social-icon-list__link text-heading flx-center">
                      <i className="fab fa-pinterest-p" />
                    </Link>
                  </li>
                  <li className="social-icon-list__item">
                    <Link to="https://www.youtube.com" className="social-icon-list__link text-heading flx-center">
                      <i className="fab fa-youtube" />
                    </Link>
                  </li>
                </ul>
              </div> */}
            </div>
          </div>

          {/* ✅ Formik Form */}
          <div className="col-lg-7 ps-lg-5">
            <div className="card common-card p-sm-4">
              <div className="card-body">
                <Formik
                  initialValues={{
                    name: "",
                    email: "",
                    message: "",
                    project: "Nomio",
                  }}
                  validationSchema={validationSchema}
                  onSubmit={async (values, { resetForm }) => {
                    try {
                      const res = await sendContactMessage(values);
                      console.log(res);
                      resetForm();
                    } catch (err) {
                      console.error(err);
                    }
                  }}
                >
                  {({ isSubmitting }) => (
                    <Form autoComplete="off">
                      <div className="row gy-4">
                        {/* message */}
                        <p className={`${message?.status ? "text-success" : "text-danger"}`}>{message?.message}</p>
                        {/* Name */}
                        <div className="col-sm-6 col-xs-6">
                          <label
                            htmlFor="name"
                            className="form-label mb-2 font-18 font-heading fw-600"
                          >
                            {t("contactUs.contactForm.fullName")}
                          </label>
                          <Field
                            type="text"
                            name="name"
                            id="name"
                            className="common-input common-input--grayBg border"
                            placeholder={t("contactUs.placeholders.fullName")}
                          />
                          <ErrorMessage name="name" component="div" className="text-danger small mt-1" />
                        </div>

                        {/* Email */}
                        <div className="col-sm-6 col-xs-6">
                          <label
                            htmlFor="email"
                            className="form-label mb-2 font-18 font-heading fw-600"
                          >
                            {t("contactUs.contactForm.email")}
                          </label>
                          <Field
                            type="email"
                            name="email"
                            id="email"
                            className="common-input common-input--grayBg border"
                            placeholder={t("contactUs.placeholders.email")}
                          />
                          <ErrorMessage name="email" component="div" className="text-danger small mt-1" />
                        </div>

                        {/* Message */}
                        <div className="col-sm-12">
                          <label
                            htmlFor="message"
                            className="form-label mb-2 font-18 font-heading fw-600"
                          >
                            {t("contactUs.contactForm.message")}
                          </label>
                          <Field
                            as="textarea"
                            name="message"
                            id="message"
                            className="common-input common-input--grayBg border"
                            placeholder={t("contactUs.placeholders.message")}
                          />
                          <ErrorMessage name="message" component="div" className="text-danger small mt-1" />
                        </div>

                        {/* Submit */}
                        <div className="col-sm-12">
                          <button
                            id="contact-us-form-button"
                            className="btn btn-main btn-lg pill w-100"
                            type="submit"
                            disabled={isSubmitting}
                          >
                            { t("contactUs.contactForm.send")}
                          </button>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
